import { render, staticRenderFns } from "./ProductShippingResume.vue?vue&type=template&id=1d95c4c2&"
import script from "./ProductShippingResume.vue?vue&type=script&lang=js&"
export * from "./ProductShippingResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports